export default (store) => {
  return (to) => {
    if (to.meta.requiresNotAuth && store.state.auth.user) {
      console.debug('Require not auth, redirect to home')
      return '/'
    }

    if (to.meta.requiresAuth && !store.state.auth.user) {
      console.debug('Require auth, redirect to login')
      return 'login'
    }

    return true
  }
}
